import { render } from "./Dashboard.vue?vue&type=template&id=2131a5ef&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=2131a5ef&scoped=true&lang=scss"
import "./Dashboard.vue?vue&type=style&index=1&id=2131a5ef&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2131a5ef"],['__file',"src/views/Dashboard/Dashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2131a5ef"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2131a5ef', __exports__)) {
    api.reload('2131a5ef', __exports__)
  }
  
  module.hot.accept("./Dashboard.vue?vue&type=template&id=2131a5ef&scoped=true", () => {
    api.rerender('2131a5ef', render)
  })

}


export default __exports__